import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Header from "../Reutilizables/Header/Header";
import Footer from "../Reutilizables/Footer/Footer";
import logo from "../../assets/language-hero-logo.png";
import "./ThankYou.css";

function ThankYou() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { i18n } = useTranslation();
  const isEnglish = i18n.language === "en";

  return (
    <div className="app-shell thank-you-page">
      <Header />
      <main className="page-main thank-you-main">
        <div className="thank-you-card">
          <img src={logo} alt="Language Hero" />
          <h1>{isEnglish ? "THANK YOU!" : "¡GRACIAS!"}</h1>
          <p>{isEnglish ? "Your message has been sent successfully." : "Tu mensaje ha sido enviado con éxito."}</p>
          <Link className="button-primary" to="/">{isEnglish ? "HOME" : "INICIO"}</Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default ThankYou;
